import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import { heritageColors } from '../../../../heritageTheme.ts';

/**
 * Columns – תבנית רשת עם מספר עמודות ניתן להגדרה
 * לייאוט אופקי – כל איש קשר בכרטיס בתוך רשת, מתאים למידות גדולות ובינוניות
 * ה-prop columns קובע את מספר העמודות (ברירת מחדל 3)
 */
const Columns = ({
  initialData = { contacts: [] },
  title = 'אנשי קשר והנהלה',
  showTitle = true,
  columns = 3,
}) => {
  const contacts = initialData.contacts || [];
  const colCount = Math.max(1, Math.min(6, columns));

  return (
    <div style={{
      padding: '1em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          borderBottom: `0.03125em solid ${heritageColors.gold}`,
          paddingBottom: '0.625em',
          marginBottom: '0.75em',
        }}>
          <GroupsIcon sx={{ color: heritageColors.navy, fontSize: '1.25em' }} />
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.navy,
            fontSize: '0.875em',
          }}>{title}</h3>
        </div>
      )}

      {contacts.length === 0 ? (
        <div style={{ color: heritageColors.slate, fontSize: '0.875em', textAlign: 'center' }}>
          אין אנשי קשר להצגה
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${colCount}, 1fr)`,
          gap: '0.625em',
          flex: 1,
          alignContent: 'start',
        }}>
          {contacts.map((contact, index) => (
            <div
              key={contact.id || index}
              style={{
                backgroundColor: '#fff',
                border: `0.03125em solid ${heritageColors.border}`,
                borderTop: `0.1875em solid ${heritageColors.navy}`,
                borderRadius: '0.375em',
                padding: '0.75em',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25em',
              }}
            >
              <div style={{
                fontSize: '0.625em',
                color: heritageColors.gold,
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.0625em',
              }}>
                {contact.role}
              </div>
              <div style={{
                fontSize: '0.875em',
                color: heritageColors.navy,
                fontWeight: 'bold',
              }}>
                {contact.name}
              </div>
              {contact.phone && (
                <div style={{
                  fontSize: '0.75em',
                  color: heritageColors.slate,
                  direction: 'ltr',
                  textAlign: 'right',
                  letterSpacing: '0.03125em',
                  marginTop: '0.125em',
                }}>
                  {contact.phone}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Columns;
